import React, { RefObject, useRef } from "react";

export const SkipToMainContentRef =
  React.createContext<RefObject<HTMLElement> | null>(null);
export const SkipLinks = ({ children }: { children: React.ReactNode }) => {
  const ref = useRef<HTMLElement>(null);
  return (
    <>
      <button
        className={
          "sr-only !absolute top-0 left-0 bg-main-color text-on-main-color focus:z-notification-layer focus:not-sr-only focus:block focus:p-2"
        }
        onClick={() => ref.current?.focus()}
      >
        Skip to Main Content
      </button>
      <SkipToMainContentRef.Provider value={ref}>
        {children}
      </SkipToMainContentRef.Provider>
    </>
  );
};
